import { LoadingZoneAdmin, CreateLoadingZoneAdminRequest, UpdateLoadingZoneAdminRequest } from '../types/loadingZone';
import { AuthService } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7141/api/v1';

class LoadingZoneServiceClass {
  private getBaseUrl(): string {
    const userContext = AuthService.getUserDataFromToken();
    if (!userContext) {
      throw new Error('No user context available');
    }
    return `${API_BASE_URL}/${userContext.companyNo}/loadingzone`;
  }

  async getLoadingZones(): Promise<LoadingZoneAdmin[]> {
    const response = await AuthService.authenticatedGet(this.getBaseUrl());
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    const data = await response.json();
    return Array.isArray(data) ? data : [];
  }

  async createLoadingZone(request: CreateLoadingZoneAdminRequest): Promise<LoadingZoneAdmin> {
    const response = await AuthService.authenticatedPost(this.getBaseUrl(), request);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    return await response.json();
  }

  async updateLoadingZone(id: number, request: UpdateLoadingZoneAdminRequest): Promise<LoadingZoneAdmin> {
    const response = await AuthService.authenticatedPut(`${this.getBaseUrl()}/${id}`, request);
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
    return await response.json();
  }

  async deleteLoadingZone(id: number): Promise<void> {
    const response = await AuthService.authenticatedFetch(`${this.getBaseUrl()}/${id}`, { method: 'DELETE' });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }
  }
}

export const loadingZoneService = new LoadingZoneServiceClass();
